/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
export const generateId = ((index = 0) => () => {
  index += 1;
  return index.toString();
})();
/**
 *
 * @param {Number} from  Lower limit
 * @param {Number} to    Upper limit
 * @param {Number} value Checked number value
 *
 * @return {Number} Either source value itself or limit value if range limits
 *   are exceeded
 */
// eslint-disable-next-line no-nested-ternary
export const inRange = (from, to, value) => (value < from ? from : value > to ? to : value);

export const createModalEvent = (args = {}) => ({
  id: generateId(),
  timestamp: Date.now(),
  canceled: false,
  ...args,
});

export const getMutationObserver = () => {
  if (typeof window !== 'undefined') {
    const prefixes = ['', 'WebKit', 'Moz', 'O', 'Ms'];

    for (let i = 0; i < prefixes.length; i += 1) {
      const name = `${prefixes[i]}MutationObserver`;

      if (name in window) {
        return window[name];
      }
    }
  }

  return false;
};

export const createDivInBody = () => {
  const div = document.createElement('div');
  document.body.appendChild(div);

  return div;
};

export const blurActiveElement = () => {
  if (
    typeof document !== 'undefined'
    && document.activeElement
    && document.activeElement.tagName !== 'BODY'
    && document.activeElement.blur
  ) {
    document.activeElement.blur();

    return true;
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/components/common/control/modal/utils/index.js